
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//马来
export const lang ={
  Please_set_materialtype_in_product_page:"Sila pergi ke halaman produk untuk mengubah suai dan menetapkan jenis bahan setiap produk - produk siap - produk separuh siap - aksesori.",
deleteAccount:"Log keluar",
deleteAccountWillDeleteAllData:"Log keluar daripada akaun anda akan memadamkan semua data dan membuat anda tidak dapat log masuk.",
backupDatabase:"pangkalan data sandaran",
restoreDatabase:"Pulihkan pangkalan data",
materialtype:"Jenis bahan",
Manufacturing:"Versi pembuatan",
Professional:"Versi profesional",
Standard:"Edisi Piawai",
product:"Produk siap",
halfProduct:"Produk separuh siap",
components:"Aksesori",
Parent:"komponen induk",
Children:"Sub-aksesori",
Level:"Hierarki",
Timing:"Masa",
PieceCount:"Kerja sekeping",
Wages:"Upah",
InternalProcess:"Proses dalaman",
ExternalProcess:"proses luaran",
ProceName:"Nama proses",
ProceIndex:"Perintah pelaksanaan",
ChargeMan:"pengetua",
BillMethod:"Kaedah pengebilan",
ConsumTime:"jam bekerja",
Accessories:"Aksesori",
Assembly:"Berhimpun",
materials:"bahan",
task:"Tugasan",
process:"proses",
BOM:"BOM",
Production:"Pengeluaran",
RestorePurchaseOneUse:"Pulihkan pembelian (satu pengguna (terhad kepada pembelian sebelumnya))",
buy_fail_try_again:"Sila klik sekali lagi untuk membeli",
Export:"Eksport",
Date:"Tarikh",
BankDetail:"Butiran bank",
Seller:"penjual",
Buver:"pembeli",
Currency:"mata wang",
CompanyName:"nama syarikat",
ProformaInvoice:"invois proforma",
Discount:"Diskaun",
PayStatus:"Status bayaran",
ShippingStatus:"Status penghantaran",
FreightType:"Jenis pengangkutan",
Shipping:"pengangkutan",
Payment:"Bayaran",
Moneyname:"nama mata wang",
Tax:"cukai",
Freight:"Kos pengangkutan",
Insurance:"insurans",
Bankfee:"yuran bank",
Qc:"Pensijilan Kualiti",
Exchangerate:"kadar pertukaran",
Shippingnumber:"nombor penghantaran",
ShipDate:"Tarikh kapal",
Arrivedate:"Tarikh ketibaan",
Grossweight:"berat kasar",
CubicWeight:"berat padu",
Totalpackages:"Jumlah bilangan pakej",
Moneytype:"jenis mata wang",
Quotedate:"tarikh sebut harga",
Validitydate:"Tarikh sah",
Paymentterm:"tamat tempoh gaji",
Priceterm:"jangka harga",
DeliveryTerm:"Masa penghantaran",
BankName:"nama bank",
BankAddress:"alamat bank",
SwiftCode:"Kod bank",
Review:"Semakan",
Signfor:"Tandatangani untuk resit",
Finance:"kewangan",
Receiver:"Penerima",
Business:"perniagaan",
ContactPerson:"Orang hubungan",
Profit:"keuntungan",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Pekerja mesti menggunakan Google Chrome. Sila semak alamat IP pada halaman bantuan APP komputer perkhidmatan utama, dan kemudian masukkan alamat dalam lajur URL pelayar komputer lain untuk membuka log masuk",
newPassword:"Kata laluan baharu",
ForgetPassword:"lupa kata laluan",
ContactUs:"Hubungi kami/buat cadangan",
Actualpay_should_big_then_shouldpay:"Penerimaan sebenar tidak boleh lebih besar daripada penerimaan",
ShopAddress:"Alamat kedai saya Imbas kod QR untuk membuat pesanan",
Submit:"serahkan",
All:"semua",
OrdernumExists:"Nombor pesanan sudah ada",
PermissionDenied:"kebenaran ditolak",
StockTransfer:"Pemindahan stok",
FromWarehouse:"Pemindahan keluar dari gudang",
ToWarehouse:"Pindah ke gudang",
PleaseUseInWebBrowser:"Sila gunakan fungsi eksport Excel dalam Google Chrome",
PleasePrintInWebBrowser:"Sila gunakan fungsi cetakan dalam Google Chrome",
HistoryPrice:"harga bersejarah",
SerialNumber:"nombor siri",
Please_Use_In_APP:"Sila gunakannya dalam perisian komputer",
Please_Purchase_In_APP:"Sila beli dalam APP, bukan dalam penyemak imbas",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Anda boleh menyambung ke pangkalan data Postgresql. Data anda akan disimpan dalam pangkalan data Postgresql. Secara lalai, anda tidak perlu menyambung ke pangkalan data Postgresql. Lalai ialah pangkalan data Sqlite tempatan.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Sambung ke pangkalan data Postgresql, data anda akan disimpan dalam pangkalan data Postgresql, dan data akan dibaca semula",
Use_sqlite_data_will_store_in_local:"Menggunakan sqlite, data akan disimpan pada mesin tempatan",
UsePostgresqlDatabase:"Menggunakan pangkalan data PGSQL",
UseSqliteDatabase:"Menggunakan pangkalan data Sqlite",
DatabaseName:"Nama pangkalan data",
Test_connect:"sambungan ujian",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Jika produk mempunyai warna atau saiz, sila isikan 0 untuk inventori awal. Selepas menambah produk, masukkan inventori dalam pembelian.",
my:"saya",
my_shop_qrcode_scan:"Kod QR kedai saya menyediakan pelanggan dengan keupayaan untuk mengimbas kod untuk membuat pesanan. Telefon bimbit pelanggan mesti disambungkan ke penghala yang sama seperti komputer anda.",
ip:"IP",
port:"Pelabuhan",
orderstatus:"Status pesanan",
image:"gambar",
Template:"templat",
Please_select_a_excel_file:"Sila pilih fail",
Please_select_only_one_excel_file:"Hanya satu fail boleh dipilih",
Connect_Internet_Login_again:"Sambung ke Internet dan log masuk semula sebelum membeliSila pergi ke halaman produk untuk mengubah suai dan menetapkan jenis bahan setiap produk - produk siap - produk separuh siap - aksesori.",

    productHasValidDate:'Produk mempunyai tempoh yang sah',
productHasColor:'Produk mempunyai saiz warna',
GeneralGoods:'Barangan am',
Selected:'Dipilih',
RestorePurchase:'Sambung semula pembelian',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Beli Invois Enterprise Edition 1 pengguna selama-lamanya',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Pembelian Invois Edisi Enterprise tidak terhad kepada pengguna dan peranti',
Purchasing:'Membeli ... Sila tunggu dengan sabar ...',
Validdate:'Tempoh sah',
Makedate:'Tarikh pengeluaran',
Batch:'Batch',
CheckVersion:'Semak versi',
Please_set_this_ip_address_on_App:'Sila tetapkan alamat IP atau alamat IP komputer pada APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Buka sambungan ini dalam komputer anda atau penyemak imbas mudah alih (sambungkan WiFi yang sama)',


    CheckVersion: 'Versi Semak',
You_need_to_purchase: 'Anda belum membeli lagi, sila tambahkan WeChat ke Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: 'Anda sudah membeli',
New_version_available: 'Terdapat versi baru',
Is_the_latest_version: 'adalah versi terkini',
    please:'sila',
input:'input',
wrong:'salah',
Verifycode:'Sahkan kod',
Upload:'Muat naik',
Download:'Muat turun',
You_need_to_purchase_to_continue_use:'Anda perlu membeli untuk terus digunakan',
CheckBuy:'Semak Pembelian',
Exists:'Wujud',
NetworkUnavailable:'rangkaian tidak tersedia',
Today:'Hari ini',
Yesterday:'Semalam',
ThisMonth:'Bulan ini',
LastMonth:'Bulan lepas',
nickname:'nama samaran',
storeName:'nama kedai',
BuyStandAlone:'membeli versi berdiri sendiri',
PermissionDenied:'Kebenaran dinafikan',
Boss:'Boss',

login:'Log masuk',
operate:'Beroperasi',
register:'Daftar',
username:'Nama pengguna',
password:'Kata laluan',
User:'Pengguna',
ok:'okey',
back:'Kembali',
success:'Kejayaan',
fail:'Gagal',
cancel:'Batalkan',
add:'Tambah',
edit:'Edit',
delete:'Padam',
refresh:'Refresh',
close:'Tutup',
cancel:'Batalkan',
return:'Kembali',
ElinkInvoice:'Invois Elink',
Purchase:'Pembelian',
BaseData:'Data Asas',
Sell:'Menjual',
PurchaseReturns:'Pulangan pembelian',
SellReturns:'Jual pulangan',
Inventory:'Inventori',
Statistics:'Statistik',
Receivable:'Boleh diterima',
Payable:'Dibayar',
Orders:'Perintah',
StockTransfer:'Pemindahan Saham',
StockRecall:'Kenang Balik Saham',
Customer:'Pelanggan',
Supplier:'Pembekal',
Warehouse:'Gudang',
Color:'Warna',
Size:'Saiz',
Category:'Kategori',
Category2:'Kategori2',
Product:'Produk',
Account:'Akaun',
AccountType:'Kategori akaun',
Staff:'Kakitangan',
typeone:'Kategori',
typetwo:'SubCategory',
ProductName:'Nama Produk',
Specification:'Spesifikasi',
Barcode:'Barcode',
Buyprice:'Harga beli',
Sellprice:'Jual harga',
Wholesaleprice:'Harga borong',
Currentstock:'Stok semasa',
Unit:'Unit',
Initstock:'Stok Init',
Parameter:'Parameter',
Remark:'Catatan',
Supplier:'Pembekal',
Customer:'Pelanggan',
Staff:'Kakitangan',
Receivable:'Boleh diterima',
payable:'boleh dibayar',
Receipts:'Penerimaan',
Paid:'Dibayar',
Preferential:'Keutamaan',
DateDay:'Tarikh',
OrderNum:'Nombor Pesanan',
Name:'Nama',
UserName:'Nama Pengguna',
IdNum:'Nombor ID',
BirthDay:'Hari Lahir',
SEX:'Seks',
Female:'Perempuan',
Male:'Lelaki',
Select:'Pilih',
Address:'Alamat',
Phone:'Telefon',
Email:'E-mel',
CardNum:'Nombor kad',
Price:'Harga',
QTY:'Qty',
SupplierCategory:'Kategori Pembekal',
CustomerCategory:'Kategori Pelanggan',
Power:'Kuasa',
Role:'Peranan',
save:'Simpan',
image:'gambar',
search:'Carian',
Year:'Tahun',
Month:'Bulan',
Day:'Hari',
Total:'Jumlah',
WorkReport:'Laporan Kerja',
Leave:'Tinggalkan',
CheckIn:'Daftar masuk',
Announcement:'Pengumuman',
Approval:'Kelulusan',
Tracking:'Penjejakan',
Bill:'Rang Undang-Undang',
OrdersDetail:'Perintah Perintah',
Expense:'Perbelanjaan',
Income:'Pendapatan',
Userfor:'Userfor',
Amount:'Jumlah',
Title:'Tajuk',
News:'Berita',
SelectFile:'Pilih fail',
Content:'Kandungan',
Cost:'Kos',
ApprovalUser:'Pengguna Kelulusan',
ApprovalStatus:'Status Kelulusan',
ApprovalRemark:'Kenyataan Kelulusan',
ApprovalDate:'Tarikh kelulusan',
SubmitDate:'Hantar Tarikh',
Status:'Status',
FromDateTime:'Dari Tarikh Masa',
ToDateTime:'Untuk Tarikh Masa',
Subject:'Subjek',
Latitude:'Latitud',
Longitude:'Longitud',
Print:'Cetak',
DataTrans:'DataTrans',
OA:'OA',
Setting:'Menetapkan',
Help:'Bantuan',
ScanOpenInPhone:'Imbas Terbuka dalam Telefon',
Building:'Bangunan',
Room:'Bilik',
HotelCheckIn:'Daftar masuk',
CheckOut:'Semak',
Hotel:'Hotel',
Checkintime:'Semak masa',
Checkouttime:'Masa daftar keluar',
Deposit:'Deposit',
Cost:'Kos',
RoomNum:'Bilik Num',
Rent:'Sewa',
costday:'harganya',
rent:'sewa',
waternum:'Ijazah air',
electricnum:'Ijazah elektrik',
gasnum:'Ijazah gas',
watercost:'kos air',
electriccost:'kos elektrik',
gascost:'kos gas',
cleaningcost:'kos pembersihan',
networkcost:'kos rangkaian',
tvcost:'kos tv',
managecost:'menguruskan kos',
othercost:'kos lain',
totalcost:'jumlah kos',
remark:'kata-kata',
addtime:'tambah masa',
OpenInBrowser:'Buka Dalam Penyemak Imbas',
InventoryProfit:'Keuntungan inventori',
InventoryLoss:'Kehilangan inventori',
Buy:'Beli',


Refresh:'Muat semula',
Add:'Tambah',
Search:'Cari',
Records:'rekod',
}



// WEBPACK FOOTER //
// ./src/lang/ms.js